import RequestUtils from "utils/RequestUtils";
import CompanyRes from "types/res/company/CompanyRes";

export default class CompanyApi {
  static async findOne(companyId: number) {
    return await RequestUtils.get(CompanyRes, `/company/findOne/${companyId}`);
  }
}
